import { combineReducers } from 'redux';

import byId from 'modules/bodyScan/reducers/data/byId';

export default combineReducers({
  byId,
});
